<template>
  <div class="top-banner" v-if="banners.length" :class="{active:!showEn}">
		<div class="banner-view">
			<div v-swiper:bannerSwiper="{
          autoplay:{
            delay: 5000
          },
          loop:true,
          on: {
            slideChange() {
              changeItem();
            }
          },
          pagination: {
            el: '.slide-pagination',
            type: 'fraction'
          },
          navigation: {
            prevEl: '.slide-button-prev',
            nextEl: '.slide-button-next'
          }
        }" class="view-inner" ref="bannerSwiper">
        <div class="swiper-wrapper" ref="swipeSlide" v-show="!showEn">
					<div class="swiper-slide" v-for="(banner, index) in banners" :key="index">
            <template v-if="banner.link">
              <component :is="banner.link.outer?'a':'router-link'" :to="banner.link.url" :target="banner.link.outer?'_blank':''"><img v-if="banner.image" :src="banner.image.source" :alt="banner.image.text" /></component>
            </template>
            <template v-else>
              <img v-if="banner.image" :src="banner.image.source" :alt="banner.image.text" />
            </template>
          </div>
				</div>
        <div class="swiper-controller" v-show="!showEn">
          <div class="inner">
            <button type="button" class="slide-button-prev">
              <i class="icon arrow-prev"></i>
              <span class="blind">{{$t('common.indicator.prev')}}</span>
            </button>
            <div class="slide-pagination"></div>
            <button type="button" class="slide-button-next">
              <i class="icon arrow-next"></i>
              <span class="blind">{{$t('common.indicator.next')}}</span>
            </button>
          </div>
        </div>
			</div>
		</div>

		<button class="banner-pager" :class="{active:showEn}" @click.prevent="openBanner()" v-if="showEn">
			<div class="pager-inner">
        <transition name="fade" v-for="(banner, index) in banners" :key="index">
				  <p class="title" v-show="activeIndex == index">{{banner.title}}</p>
        </transition>
      </div>
      <div class="pager-dots" v-if="banners.length>1">
        <div class="dot" v-for="(dot, index) in banners" :class="{'active': activeIndex == index}"></div>
      </div>
		</button>

    <button type="button" @click="closeBanner()" class="btn-close" v-if="!showEn">
      <i class="icon close"></i>
      <span class="blind">{{$t('common.button.close')}}</span>
    </button>

	</div>

</template>

<script>
import {mapActions} from 'vuex';
export default {
  props: ['bannerList'],
	data() {
		return {
			slideHeight:'',
			showEn: true,
			scrolled: false,
			isSelected: false,
      activeIndex: 0,
			banners: [...this.bannerList] || []
		}
	},
  watch: {
	  '$route.path' () {
      this.closeBanner()
    }
  },
	methods: {
    ...mapActions([ 'setTopBanner' ]),
		openBanner: function () {
		  this.$refs['bannerSwiper'] && this.$refs['bannerSwiper'].swiper.autoplay.stop();
			this.showEn = false
      this.setTopBanner(470)
		},
		closeBanner: function () {
      this.$refs['bannerSwiper'] && this.$refs['bannerSwiper'].swiper.autoplay.start();
      this.showEn = true
      this.setTopBanner(this.banners.length?60:0)
		},
    changeItem(){
      this.$refs['bannerSwiper'] && (this.activeIndex = this.$refs['bannerSwiper'].swiper.realIndex);
    }
	},
  mounted() {
    if(this.banners && this.banners.length){
      this.setTopBanner(60);
    }else{
      this.setTopBanner(0);
    }

	  // this.$http.get('/contents/v1/banner/global-top').then((response)=>{
	  //   let data = response.data;
	  //   if(data.length){
    //     this.banners = response.data;
    //     this.setTopBanner(60);
    //   }else{
	  //     this.setTopBanner(0);
    //   }
    // })
		// window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		// window.removeEventListener('scroll', this.handleScroll);
	}

}
</script>

<style src="./style.scss" lang="scss" scoped />
